<template>
  <div
    class="date-range-filter"
    data-testid="date-range-filter"
    :data-draft-from="draft.from || ''"
    :data-draft-to="draft.to || ''"
  >
    <q-btn
      ref="trigger"
      outline
      no-caps
      icon="date_range"
      :label="triggerLabel"
      :aria-expanded="open ? 'true' : 'false'"
      @click="toggle"
    />
    <div v-if="open" class="date-range-filter__panel" role="dialog" aria-label="Выбор периода">
      <div class="date-range-filter__presets" aria-label="Быстрый выбор периода">
        <q-btn v-for="preset in presets" :key="preset.key" flat no-caps :label="preset.label" :data-testid="`date-range-preset-${preset.key}`" @click="selectPreset(preset)" />
      </div>
      <div class="date-range-filter__calendars">
        <div><div class="date-range-filter__label">Начало</div><q-date v-model="draft.from" minimal mask="YYYY-MM-DD" /></div>
        <div><div class="date-range-filter__label">Конец</div><q-date v-model="draft.to" minimal mask="YYYY-MM-DD" /></div>
      </div>
      <div class="date-range-filter__actions">
        <q-btn flat no-caps label="Сбросить" @click="resetRange" />
        <q-space />
        <q-btn flat no-caps label="Отмена" @click="cancel" />
        <q-btn color="primary" no-caps label="Применить" data-testid="date-range-apply" @click="commitRange" />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

function today() {
  return moment().format('YYYY-MM-DD')
}

export default {
  name: 'DateRangeFilter',
  emits: ['apply', 'apply-range', 'reset', 'update:modelValue'],
  props: {
    modelValue: {
      type: Object,
      default: () => ({ from: '', to: '' })
    },
    label: { type: String, default: 'Период' }
  },
  data() {
    return {
      open: false,
      draft: { ...this.modelValue },
      presets: [
        { key: 'month', label: 'Этот месяц', from: () => moment().startOf('month').format('YYYY-MM-DD'), to: today },
        { key: 'quarter', label: 'Этот квартал', from: () => moment().startOf('quarter').format('YYYY-MM-DD'), to: today },
        { key: 'year', label: 'Этот год', from: () => moment().startOf('year').format('YYYY-MM-DD'), to: today }
      ]
    }
  },
  computed: {
    triggerLabel() {
      if (!this.modelValue.from && !this.modelValue.to) return this.label
      return `${this.modelValue.from || '…'} — ${this.modelValue.to || '…'}`
    }
  },
  watch: {
    modelValue: {
      deep: true,
      handler(value) {
        if (!this.open) this.draft = { ...value }
      }
    },
    open(value) {
      if (value) this.draft = { ...this.modelValue }
    }
  },
  methods: {
    toggle() {
      this.open = !this.open
    },
    closeAndReturnFocus() {
      this.open = false
      this.$nextTick(() => {
        const triggerRef = this.$refs.trigger
        const trigger = triggerRef && (triggerRef.$el || triggerRef)
        if (trigger && typeof trigger.focus === 'function') trigger.focus()
      })
    },
    selectPreset(preset) {
      this.draft = { from: preset.from(), to: preset.to() }
    },
    commitRange() {
      const value = { from: this.draft.from || '', to: this.draft.to || '' }
      this.$emit('update:modelValue', value)
      this.$emit('apply', value)
      this.$emit('apply-range', value)
      this.closeAndReturnFocus()
    },
    cancel() {
      this.draft = { ...this.modelValue }
      this.closeAndReturnFocus()
    },
    resetRange() {
      const value = { from: '', to: '' }
      this.draft = value
      this.$emit('update:modelValue', value)
      this.$emit('reset')
      this.closeAndReturnFocus()
    }
  }
}
</script>

<style scoped>
.date-range-filter { position: relative; }
.date-range-filter__panel {
  position: absolute;
  z-index: 2000;
  top: calc(100% + var(--sid-space-1));
  left: 0;
  width: min(44rem, calc(100vw - 2rem));
  padding: var(--sid-space-4);
  border: 1px solid var(--sid-color-line);
  border-radius: var(--sid-radius-large);
  background: var(--sid-color-surface-0);
  box-shadow: var(--sid-elevation-3);
}
.date-range-filter__presets, .date-range-filter__actions { display: flex; align-items: center; gap: var(--sid-space-2); }
.date-range-filter__calendars { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: var(--sid-space-4); margin: var(--sid-space-3) 0; }
.date-range-filter__label { margin-bottom: var(--sid-space-1); font-weight: var(--sid-font-weight-medium); }
@media (max-width: 599px) {
  .date-range-filter__panel { position: relative; top: auto; width: 100%; margin-top: var(--sid-space-2); padding: var(--sid-space-2) 0 0; border: 0; box-shadow: none; }
  .date-range-filter__calendars { grid-template-columns: 1fr; max-height: 60vh; overflow-y: auto; }
  .date-range-filter__presets, .date-range-filter__actions { flex-wrap: wrap; }
}
</style>
